module.exports = __webpack_public_path__ + "static/makingJesusKnown-418b4f1baf4088add86fbadd5c75d474.jpg";